import api from './api'

export {
  api
}



// WEBPACK FOOTER //
// ./src/services/index.js